export default __webpack_public_path__ + "static/media/timeline_01.717564c6.png";